module.exports = __webpack_public_path__ + "static/img/wechat.dcd1c36c.png";